import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { IEditReportModel, IReportParams, ICreateReportModel } from "../../entities/edit-report-model";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { ReportServices } from "../../scripts/ah.mb.report-services";
import { ITagObject } from "../../entities/tag-object";
import { IMultiSelectItem } from "../../infrastructure/multi-select-item";
import { IModelInfo } from "../../entities/nu-model-info";

export interface IReportEditorConfig {
    modelId: string;
    mode: "edit" | "create";
    reportParams: IReportParams;
    reportNodePath: string;
    reportName: string;
    reportNodePathAndName: string;
    modelInfo: IModelInfo;

}

@Component
export default class ReportEditorDialog extends Vue {


    @Prop()
    value: IReportEditorConfig; // = { mode: "create",  }


    @Prop()
    reportServices: ReportServices;

    @Prop()
    modelServices: modelServices;

    modelIdForLookups: string = "";
    tagAndOr: "and" | "or" = "and";
    interpolateResults: boolean = false;
    includePriceDifferential: boolean = false;
    includeCapAddDisabledNodes: boolean = false;

    nodeTypesList: Array<IMultiSelectItem> = [];
    timePointLookup: string[] = [];

    tag: string = "";
    tags: ITagObject[] = [];
    tagAutoCompleteDebounce = null;

    nodeTagAutocompleteItems: Array<ITagObject> = [];
    excludeTag: string = "";
    excludeTags: ITagObject[] = [];


    scenarioNamesSelection: Array<IMultiSelectItem> = [];

    static linkDataResultTypes = ["Both", "Price", "Quantity"];

    setupTimePointLookup(modelId: string) {
        if (modelId)
            FetchWrapper.fetch(`/api/1.0/nodes/getnodedata?modelId=${modelId}
            &nodePathAndName=&variableName=GlobalModelTimeVector`, { method: "get" })
                .then(response => response.json())

                .then((data) => {
                    //console.log(data);
                    this.timePointLookup = data[0].value.map(d => d[0]);

                });
    }

    setupNodeTypesLookup(modelId: string) {

        if (modelId)
            // Setup multi-select for node types
            this.modelServices.getNodeTypes(modelId,
                "")
                .then(nodeTypes => {

                    // Need to transform the api results into objects compatible with the multi-select control
                    var nodeTypeObjects = nodeTypes.nodes[0].children;
                    this.nodeTypesList = nodeTypeObjects.map(item => ({
                        label: item.title,
                        value: item.title
                    }));
                });


    }

    mounted() {
        // this.setupNodeTypesLookup(this.value.modelId);
    }

    needsQueryStringEdit(): boolean {
        const isNodeData = $("#resultTypeNodeDataRadio").is(":checked");
        const isTimePointQueryString = $("#resultTypeSupplyByLevelizedCost").is(":checked");
        return isNodeData || isTimePointQueryString;
    }

    @Watch("value.modelId", { deep: false })
    onModelIdChanged() {
        this.onReportNodePathAndNameChanged();
    }

    @Watch("value.reportNodePathAndName", { deep: false })
    onReportNodePathAndNameChanged() {

        this.tags = this.value.reportParams.nodeTags.map(tag => {
            return { text: tag }
        });

        this.excludeTags = this.value.reportParams.excludeNodeTags.map(tag => {
            return { text: tag }
        });

        const tagAndOr = this.value.reportParams.configuration["tagAndOr"];
        if (tagAndOr)
            this.tagAndOr = tagAndOr;
        else
            this.tagAndOr = "and";

        const includePriceDifferential = this.value.reportParams.configuration["IncludePriceDifferential"];
        if (includePriceDifferential)
            this.includePriceDifferential = includePriceDifferential;
        else
            this.includePriceDifferential = false;

        const includeCapAddDisabledNodes = this.value.reportParams.configuration["IncludeCapAddDisabledNodes"];
        if (includeCapAddDisabledNodes)
            this.includeCapAddDisabledNodes = includeCapAddDisabledNodes;
        else
            this.includeCapAddDisabledNodes = false;

        const interpolateResults = this.value.reportParams.configuration["interpolateResults"];
        if (interpolateResults)
            this.interpolateResults = interpolateResults;
        else
            this.interpolateResults = false;

        if (this.value.modelId !== this.modelIdForLookups) {

            this.setupNodeTypesLookup(this.value.modelId);
            this.setupTimePointLookup(this.value.modelId);
            this.refreshScenarioNamesSelection(this.value.modelId);
            this.modelIdForLookups = this.value.modelId;
        }
    }

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }

    // Todo: Hook this up to ok button
    onSaveClick() {

        //const config = { "tagAndOr": this.tagAndOr };
        this.value.reportParams.configuration["tagAndOr"] = this.tagAndOr;
        this.value.reportParams.configuration["interpolateResults"] = this.interpolateResults;
        this.value.reportParams.configuration["IncludePriceDifferential"] = this.includePriceDifferential;
        this.value.reportParams.configuration["IncludeCapAddDisabledNodes"] = this.includeCapAddDisabledNodes;

        var chooser = (this.$refs.scenarioChooser) as any;
        // this.value.reportParams.scenarioNames = chooser.selectedScenarioNames as Array<string>;

        switch (this.value.mode) {
            case "create":

                var theModel: ICreateReportModel = { ...this.value.reportParams, scriptName: this.value.reportNodePath, name: this.value.reportName };

                // Call the api to create the new report
                this.reportServices.createReport(this.value.modelId, theModel)
                    .then(() => {
                        this.$emit("dialogClosed", "ok");
                    });
                break;

            case "edit":
                {
                    var editModel: IEditReportModel = { ...this.value.reportParams, reportName: this.value.reportNodePathAndName, newName: this.value.reportName };
                    // Call the api to create the new report
                    this.reportServices.editReport(this.value.modelId, editModel)
                        .then(() => {
                            this.$emit("dialogClosed", "ok");
                        });
                    break;

                }
        }

    }


    variableSearchFunction(query: string, done: (any) => void) {
        const selectedNodes = this.value.reportParams.nodeTypes.length > 0 ? this.value.reportParams.nodeTypes[0] : "(All nodes)";
        const url = `/api/1.0/nodes/getnodetypevariables?modelId=${this.value.modelId}&nodeType=${selectedNodes}&filter=${query}`;

        FetchWrapper.fetch(url, { method: "get" })
            .then(res => res.json())
            .then((res: any) => {
                var namesOnly = res.map(p => p.variableName);
                done(namesOnly);
            });
    }


    sectorSearchFunction(query: string, done: (any) => void) {
        const searchUrl = this.modelServices.getNodeSearchUrl(this.value.modelId, { searchPathAndName: query });

        FetchWrapper.fetch(searchUrl, { method: "get" })
            .then(res => res.json())
            .then((res: any) => {
                var namesOnly = res.map(p => p.name);
                done(namesOnly);
            });
    }

    onTagsChanged(tags: Array<ITagObject>) {
        this.value.reportParams.nodeTags = tags.map(p => p.text);
    }

    onExcludeTagsChanged(tags: Array<ITagObject>) {
        this.value.reportParams.excludeNodeTags = tags.map(p => p.text);
    }

    refreshScenarioNamesSelection(modelId: string) {
        if (modelId)
            this.modelServices.getScenarioNames(modelId)
                .then(value => {
                    this.scenarioNamesSelection = value.map(item => ({
                        label: item.name, value: item.name
                    }));
                    this.value.reportParams.scenarioNames = this.scenarioNamesSelection.map(p => p.value);
                });

    }


    @Watch("tag")
    tagChanged() {

        if (this.tag.length < 2) return;

        const url = `/api/1.0/nodetags/suggestions?modelId=${this.value.modelId}&searchterm=${this.tag}`;


        clearTimeout(this.tagAutoCompleteDebounce);
        this.tagAutoCompleteDebounce = setTimeout(() => {
            FetchWrapper.fetch(url, { method: "get" })
                .then(response => response.json())
                .then((response: Array<string>) => {
                    this.nodeTagAutocompleteItems = response.map(a => {
                        return { text: a };
                    });
                });
        }, 600);
    }

    isLinkDataResultType(resultType: string): boolean {
        return ReportEditorDialog.linkDataResultTypes.indexOf(resultType) >= 0;
    }

}





// WEBPACK FOOTER //
// ./ClientApp/components/report-editor-dialog/report-editor-dialog.ts